import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import "./style.css";

interface Office {
  id: string;
  name: string;
  address: string;
  email: string;
  phone: string;
  fax?: string;
}

export function ContactPage() {
  const [headerImage, setHeaderImage] = useState("");
  const [offices, setOffices] = useState<Office[]>([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    consent: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "contact_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setOffices(data.offices || []);
      }
    };
    fetchData();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    if (type === "checkbox" && e.target instanceof HTMLInputElement) {
        //@ts-ignore
      setFormData((prev) => ({ ...prev, [name]: e.target.checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.consent) {
      alert("Trebuie să accepți termenii pentru a trimite.");
      return;
    }

    // TODO: conectare cu email service (Firebase Function, Gmail, etc.)
    alert("Mesaj trimis (simulat)");
    setFormData({ name: "", email: "", message: "", consent: false });
  };

  return (
    <div className="page-container">
      <Navbar />

      {headerImage && (
        <div
          className="contact-banner"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
      )}

      <div className="page-content contact-grid">
        <div className="contact-form">
          <h2>Ia legătura cu noi</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Nume și Prenume"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Mesaj"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <label className="checkbox">
              <input
                type="checkbox"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
              />
              Sunt de acord cu termenii și condițiile
            </label>
            <button type="submit">Trimite</button>
          </form>
        </div>

        <div className="office-list">
          {offices.map((office) => (
            <div key={office.id} className="office-box">
              <strong>{office.name}</strong>
              <p>{office.address}</p>
              <p>Email: {office.email}</p>
              <p>Tel: {office.phone}</p>
              {office.fax && <p>Fax: {office.fax}</p>}
            </div>
          ))}
        </div>
      </div>

      <div className="map-embed">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.6704167525545!2d26.13549347715691!3d44.439922471075704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff66ac9d168d%3A0x40b87c685d1386ef!2sUniunea%20Sanitas%20Bucuresti!5e0!3m2!1sen!2sro!4v1750220883042!5m2!1sen!2sro"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      <Footer />
    </div>
  );
}
